import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { SaleOfferLineOther } from '../sale-offer-line-other';
import { parseNumber } from '../../utils/number.utils';

export class SaleOfferLineOtherBuilder {

  static fromJson(json): SaleOfferLineOther {
    return (json) ? new SaleOfferLineOther(
      json.hash,
      json.concept,
      parseNumber(json.amount)
    ) : null;
  }

  static fromJsonList(list): SaleOfferLineOther[] {
    return (isArray(list)) ? sortByNumber('amount', mapCollection(SaleOfferLineOtherBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-line-other-builder.ts